import React from 'react';
import { Badge, Tabs, Tab, Paper } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    'aria-controls': `scrollable-auto-tabpanel-${index}`,
  };
}

const EnabledTabs = ({ value, handleChange, showBadge, embeddedConf, loggedUser }) => {
  const { t } = useTranslation();

  const tabList = [
    { key: "COMPARISON_TAB_VIEW", label: "COMPARE", index: 0, badge: "comparation" },
    { key: "GRAPHS_TAB_VIEW", label: "GRAPHS", index: 3, badge: "graphics" },
    { key: "NOTES_TAB_VIEW", label: "NOTES", index: 2, badge: "notes" },
    { key: "ZONING_TAB_VIEW", label: "FERTILIZER", index: 6, badge: "fertilizers" },
    { key: "WEATHER_FORECAST_TAB_VIEW", label: "WEATHER FORECAST", index: 1, badge: "wheather_forecast" },
    { key: "ADVANCED_TAB_VIEW", label: "ADVANCED", index: 4, badge: "advanced" },
    { key: "PLAGUES_TAB_VIEW", label: "PLAGUES", index: 7, badge: "plagues", show: (user) =>
      user?.is_superuser || user?.profile?.can_view_plagues || user?.profile?.can_view_and_add_plagues },
    { key: "TREE_ANALYSIS_TAB_VIEW", label: "TREE ANALYSIS", index: 8, badge: "tree counting" },
    { key: "CROPS_TAB_VIEW", label: "CROPS", index: 5, badge: "crops" },
    { key: "VEGETATION_NUTRITION_TAB_VIEW", label: "VEGETATION NUTRITION", index: 9, badge: "vegetation nutrition", show: (user) =>
      user?.is_superuser || ["widhoc", "greenfield", "cperez"].includes(user?.username) }
  ];

  return (
    <Paper style={{ display: 'flex', justifyContent: 'center' }}>
      <Tabs
        value={value}
        onChange={handleChange}
        indicatorColor="primary"
        textColor="primary"
        variant="scrollable"
      >
        {tabList.map(tab =>
          (!tab.show || tab.show(loggedUser)) &&
          (!embeddedConf?.hasOwnProperty(tab.key) || embeddedConf[tab.key]) ? (
            <Tab
              key={tab.key}
              value={tab.index}
              label={
                <Badge badgeContent={''} invisible={showBadge(tab.badge)} color="secondary">
                  {t(tab.label)}
                </Badge>
              }
              {...a11yProps(tab.index)}
            />
          ) : null
        )}
      </Tabs>
    </Paper>
  );
};

export default EnabledTabs;